let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f4Itd")).then(() => parcelRequire('jz5XV'));